var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#1C9B21"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6673 34.4666V35.9999C52.6653 39.594 51.5015 43.0911 49.3495 45.9696C47.1976 48.8482 44.1728 50.9541 40.7262 51.9731C37.2797 52.9921 33.5961 52.8698 30.2248 51.6242C26.8535 50.3787 23.9751 48.0768 22.0189 45.0617C20.0628 42.0467 19.1336 38.48 19.3701 34.8938C19.6066 31.3075 20.996 27.8938 23.3311 25.1617C25.6662 22.4296 28.822 20.5256 32.3276 19.7335C35.8333 18.9415 39.5011 19.3038 42.784 20.7666M52.6673 22.6666L36.0007 39.3499L31.0007 34.3499",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingCancelled);
export default __webpack_public_path__ + "static/media/BookingCancelled.453c62fe63c85551131294fed8c2f672.svg";
export { ForwardRef as ReactComponent };